function holidayFilter(mealName) {
  return mealName !== '-' && !mealName.toLowerCase().includes('holiday');
}

export default holidayFilter;



// WEBPACK FOOTER //
// ./src/utils/holidayFilter.js